/**
 * scanApi.ts - wrapper pour les endpoints /api/scans (per-tenant, no clientId needed).
 */
import { apiFetch } from './apiClient';

export interface CheckResult {
  ControlId:   string;
  Status:      'pass' | 'fail' | 'warn' | 'skipped' | 'error' | string;
  Score:       number;
  Message:     string;
  /** Cle i18n pour la nouvelle approche multi-locale (ex: 'check.dp001.manual'). */
  MessageKey?: string;
  /** Variables a interpoler dans la cle. */
  MessageVars?: Record<string, string | number>;
  EvaluatedAt: string;
  EvidenceUrl?: string | null;
}

export interface ScanProgress {
  current:        number;
  total:          number;
  currentControl: string;
  recentResults?: CheckResult[];
}

export interface ScanDoc {
  id:           string;
  scanId:       string;
  clientId:     string;
  status:       'queued' | 'running' | 'done' | 'error' | string;
  scanType:     'full' | 'partial';
  triggeredBy:  string;
  startedAt:    string;
  finishedAt?:  string | null;
  globalScore?: number | null;
  m365TenantId: string;
  clientSlug:   string;
  errorMessage?: string;
  results?:     CheckResult[];
  progress?:    ScanProgress;
  meta?: {
    catalogVersion?:   string;
    subscriptionPlan?: string;
    organizationName?: string;
  };
}

// Note : la gestion 401 → session-expired event est dans apiFetch (apiClient.ts)

export const scanApi = {
  /** Trigger un nouveau scan pour le tenant courant */
  trigger: (scanType: 'full' | 'partial' = 'full') =>
    apiFetch<ScanDoc>('/scans', {
      method: 'POST',
      body:   JSON.stringify({ scanType }),
    }),

  /** Liste les scans du tenant courant */
  list: (limit = 20) =>
    apiFetch<{ items: ScanDoc[]; total: number }>(`/scans?limit=${limit}`),

  /** Recupere un scan particulier (avec results detailles) */
  get: (scanId: string) =>
    apiFetch<ScanDoc>(`/scans/${encodeURIComponent(scanId)}`),
};
